import type { ActionArgs } from 'xstate5';

import type { Context } from './context';
import type { Event } from './events';

// ─────────────────────────────────────────────────────────────────────────────

export type CustomizationMachineAction<
  ActionParams extends Record<string, unknown> | void = void,
> = (
  actionArgs: ActionArgs<Context, Event, Event>,
  params: ActionParams,
) => void;
